import { observer } from 'mobx-react-lite'

import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

import { NoteStack, Payments, Person } from '@mxenabled/mx-icons'

import { H2, P, Text } from '@mxenabled/mxui'

import { SingleSegmentDonut, useGlobalCopyStore } from '../../../common'
import { type Goal, TrackType } from '../../../core'

import { getGoalStatusData } from '../../../core/utils/GoalsUtil'

interface GoalStatusCardProps {
  goal: Goal
}

export const GoalMicroStatusCard = observer(({ goal }: GoalStatusCardProps) => {
  const { goals: copy } = useGlobalCopyStore()

  const theme = useTheme()

  const {
    backgroundColor: bgcolor,
    color,
    percentage,
    projectedText,
  } = getGoalStatusData(copy, goal)

  const percentNumber = Math.round(percentage * 100)

  let avatarIcon = <Payments />
  if (goal.track_type === TrackType.DEBT_TRACK) {
    avatarIcon = <NoteStack />
  } else if (goal.track_type === TrackType.RETIREMENT_TRACK) {
    avatarIcon = <Person />
  }

  return (
    <Stack alignItems="center" direction="row" spacing={12} sx={{ py: 12 }}>
      <Avatar sx={{ bgcolor, color, height: 32, width: 32 }} variant="rounded">
        {avatarIcon}
      </Avatar>
      <Box sx={{ width: '100%' }}>
        <H2 fontSize={15} fontWeight={600} variant="body1">
          {goal.name}
        </H2>
        {goal.projected_to_complete_at && (
          <Text color="text.secondary" variant="caption">
            {projectedText}
          </Text>
        )}
      </Box>
      <SingleSegmentDonut
        backgroundStrokeColor={theme.palette.neutral.light}
        color={theme.palette.primary.main}
        percent={percentNumber}
        size={40}
        strokeWidth={3}
      >
        <P fontWeight={700} variant="caption">
          {`${percentNumber}%`}
        </P>
      </SingleSegmentDonut>
    </Stack>
  )
})
